import React from "react";

/**
 * Minimal footer for LP / bare-route pages.
 * Shown on /lp/*, /newoffer, /upsell/* where the global Footer is hidden.
 */
export default function LPFooter() {
  return (
    <footer className="bg-white border-t border-gray-100 py-6 px-6 text-center">
      <p className="text-sm text-gray-500 mb-1">
        For any queries, reach out to us at{" "}
        <a
          href="mailto:support@mail.placementos.ai"
          className="text-[#FF6B35] font-medium hover:underline"
        >
          support@mail.placementos.ai
        </a>
      </p>
      <p className="text-xs text-gray-400">
        © {new Date().getFullYear()} PlacementOS. All rights reserved.{" "}
        <a href="/privacy-policy" className="hover:underline">Privacy Policy</a>
        {" · "}
        <a href="/terms-of-service" className="hover:underline">Terms of Service</a>
      </p>
    </footer>
  );
}
